import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ISearchSuggestionHoverXP } from "@faire/web-api--source/indigofair/data/ISearchSuggestionHoverXP";
import { LISP_SUGGESTION_HOVER_SPECULATION_241118 } from "@faire/web-api--source/indigofair/settings/LISP_SUGGESTION_HOVER_SPECULATION_241118";
import { LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130 } from "@faire/web-api--source/indigofair/settings/LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130";
export var useSettingSearchSuggestionHoverSpeculation = function() {
    return useSetting(LISP_SUGGESTION_HOVER_SPECULATION_241118, false);
};
export var useAssignSettingSearchSuggestionHoverSpeculation = function() {
    return useAssignSetting(LISP_SUGGESTION_HOVER_SPECULATION_241118);
};
export var useSettingSearchSuggestionHoverSpeculationRelaunch = function() {
    return useSetting(LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130, ISearchSuggestionHoverXP.Bucket.CONTROL);
};
export var useAssignSettingSearchSuggestionHoverSpeculationRelaunch = function() {
    return useAssignSetting(LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130);
};
